import { DEFAULT_ADMIN_OBSERVATION_ANSWERS } from "src/features/observationsAdmin/constants";
import { getQuestionIdByType } from "src/utils/getQuestionType";

const formatQuestions = (data?: IAdminObservationForm) => {
	if (!data) return null;

	if (!data.observation_questions) return null;

	const formattedQuestions = data.observation_questions?.map((question) => {
		const formatAnswers = () => {
			if (!question.observation_answers) return null;

			if (!question.observation_answers.length)
				return DEFAULT_ADMIN_OBSERVATION_ANSWERS;

			return question.observation_answers.map((answer) => {
				const getObservationTypeValueLogic = () => {
					const { observation_type } = data;

					if (observation_type === "INDIVIDUAL") {
						return answer.compliant ? "yes" : "no";
					}

					if (observation_type === "GREAT_CONVERSATION") {
						return question.is_correct_answer_required
							? answer.great_conversation_correct
								? "yes"
								: "no"
							: "";
					}

					return answer.store_correct ? "yes" : "no";
				};

				return {
					...answer,
					value: getObservationTypeValueLogic()
				};
			});
		};

		return {
			order: question.order,
			type: question.question_type ?? null,
			questionTypeId:
				question.question_type_id ??
				getQuestionIdByType(question.question_type),
			question: question.question,
			note: question.note,
			id: question.id,
			answers: formatAnswers(),
			image: question.image_cover_id,
			isActionRequired: question.is_action_required,
			isCorrectAnswerRequired: question.is_correct_answer_required,
			goTo: question.go_to
		};
	});

	return formattedQuestions;
};

export default formatQuestions;
